import * as Yup from 'yup'

export const CarrierSchema = Yup.object({
  id: Yup.string()
    .nullable()
    .required('form.validation.required'),
  contactInfo: Yup.object({
    infoText: Yup.string(),
    emails: Yup.array()
      .required('form.validation.required')
      .min(1, 'form.validation.required'),
  })
    .nullable()
    .required('form.validation.required'),
  isInternal: Yup.bool().nullable(),
  internalCar: Yup.object({
    carId: Yup.string()
      .nullable()
      .required('form.validation.required'),
  })
    .nullable()
    .when('isInternal', (isInternal, schema) =>
      isInternal === true
        ? schema.required('form.validation.required')
        : schema,
    ),
  externalCar: Yup.object({
    carRegistrationNumber: Yup.string().required('form.validation.required'),
    driverInfo: Yup.string(),
  })
    .nullable()
    .when('isInternal', (isInternal, schema) =>
      isInternal === false
        ? schema.required('form.validation.required')
        : schema,
    ),
})

export const CarrierFormValues = {
  noCarrierSelected: () => ({
    id: null,
    contactInfo: {
      emails: [],
      infoText: '',
    },
    isInternal: true,
    internalCar: {
      carId: null,
      driverId: null,
    },
    externalCar: null,
    hvExpirationDate: null,
    carrierVerificationExpirationDate: null,
  }),
  withExternalCarRegistrationNumberEntered: (value, carRegistrationNumber) => ({
    ...value,
    isInternal: false,
    internalCar: null,
    externalCar: {
      carRegistrationNumber,
      driverInfo: '',
    },
  }),
  withInternalCarNotSelected: (value) => ({
    ...value,
    isInternal: true,
    internalCar: {
      carId: null,
      driverId: null,
    },
    externalCar: null,
  }),
  withCarrierSelected: (value, carrierId) => ({
    id: carrierId,
    contactInfo: {
      emails: [],
      infoText: '',
    },
    isInternal: true,
    internalCar: {
      carId: null,
      driverId: null,
    },
    externalCar: null,
  }),
  withInternalCarSelected: (value, car) => ({
    ...value,
    id: car.carrierId,
    isInternal: true,
    internalCar: {
      carId: car.id,
      driverId: car.driver.id,
    },
    externalCar: null,
  }),
  fromDeliveryMethod: (deliveryMethod) => {
    if (deliveryMethod.internal) {
      return fromInternalDeliveryMethod(deliveryMethod.internal)
    }
    if (deliveryMethod.external) {
      return fromExternalDeliveryMethod(deliveryMethod.external)
    }
    throw new Error('Unknown delivery method')
  },
  withAdditionalInfoCopiedFromCarrier: (value, carrier) => ({
    ...value,
    contactInfo: {
      emails: [],
      infoText: '',
    },
    hvExpirationDate: carrier.hvExpirationDate,
    carrierVerificationExpirationDate: carrier.carrierVerificationExpirationDate,
  }),
}

const fromInternalDeliveryMethod = (internal) => ({
  id: internal.carrierId,
  contactInfo: internal.carrierContactInfo,
  isInternal: true,
  internalCar: {
    carId: internal.carId,
    driverId: internal.driverId,
  },
  externalCar: null,
})

const fromExternalDeliveryMethod = (external) => ({
  id: external.carrierId,
  contactInfo: external.carrierContactInfo,
  isInternal: false,
  externalCar: {
    carRegistrationNumber: external.carRegistrationNumber,
    driverInfo: external.driverInfo,
  },
  internalCar: null,
})